import React from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

// ===============================|| UI DIALOG - SWEET ALERT ||=============================== //

export default function AlertConfirmacion({
  handleClickOpen,
  handleClose,
  handleConfirmacion,
  message = "...",
}) {
  const theme = useTheme();

  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //     setOpen(true);
  // };

  // const handleClose = () => {
  //     setOpen(false);
  // };

  // const handleConfirmacion = () => {
  //     setConfirmation(true)
  //     setOpen(false);
  //     return confirmation;
  // }

  return (
    <>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
                Abrir cartel de dialogo
            </Button> */}
      <Dialog
        open={handleClickOpen} //abre y cierra el modal
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ p: 3 }}
      >
        <DialogTitle id="alert-dialog-title">
          Desea confirmar o cancelar la acción de {message}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body2" component="span">
              Tenga en cuenta que el cambio quedara ascentado luego segun la
              instancia se podra modificar o no
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pr: 2.5 }}>
          <Button
            style={{
              color: "#002878",
              fontWeight: 500,
              borderColor: "#002878",
              "&:hover": { borderColor: "#002878" },
              width: "100px",
              textTransform: "uppercase",
            }}
            onClick={handleClose}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#002878",
              textTransform: "uppercase",
              width: "100px",
              fontWeight: 500,
              paddingX: "15px",
              paddingY: "5px",
              fontSize: "14px",
              color: "#FFFFFF",
              "&:hover": { backgroundColor: "#002878", color: "#FFFFFF" },
            }}
            onClick={handleConfirmacion}
            autoFocus
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
